
if (document.querySelector('.steps-slider-container')) {
    jQuery('.steps-slider-container').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        fade: false,
        dots: true,
        arrows: false,
    });
}
